import { render, staticRenderFns } from "./ConsentCreationFailure.vue?vue&type=template&id=8d1f268c&scoped=true"
import script from "./ConsentCreationFailure.vue?vue&type=script&lang=js"
export * from "./ConsentCreationFailure.vue?vue&type=script&lang=js"
import style0 from "./ConsentCreationFailure.vue?vue&type=style&index=0&id=8d1f268c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1f268c",
  null
  
)

export default component.exports